import React from 'react';
import { Calendar } from 'lucide-react';
import { REPORT_ACCENT } from './reportTheme';

// CTV-445: a small "Last 30 days" / "Apr 10 – Apr 20" pill shown next to a
// section title when the report is scoped by the global date-range filter.
// Renders nothing when there's no active filter (the full flight window).
const RangeBadge: React.FC<{ label?: string | null; accentColor?: string }> = ({ label, accentColor }) => {
  if (!label) return null;
  const accent = accentColor || REPORT_ACCENT;
  return (
    <span
      // No vertical padding: the pill matches the title's line height so showing
      // it doesn't grow the eyebrow row (which would nudge the whole section down).
      className="inline-flex items-center gap-1 rounded-full px-2 text-[10px] font-medium normal-case tracking-normal"
      style={{ color: accent, backgroundColor: `${accent}14` }}
    >
      <Calendar className="w-2.5 h-2.5" />
      {label}
    </span>
  );
};

export default RangeBadge;
